
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("k9PUn", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $fd3e8076f980c90d$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/import-whitelist

var $bFU4G = parcelRequire("bFU4G");

var $9IjUd = parcelRequire("9IjUd");

var $x9xyg = parcelRequire("x9xyg");

var $2YZCu = parcelRequire("2YZCu");

var $jcw0u = parcelRequire("jcw0u");

var $6s1PB = parcelRequire("6s1PB");

var $7f4tk = parcelRequire("7f4tk");

var $8PRuf = parcelRequire("8PRuf");

var $dK8AG = parcelRequire("dK8AG");

var $9NiTW = parcelRequire("9NiTW");

var $3RV1W = parcelRequire("3RV1W");
const $fd3e8076f980c90d$var$onFetchErrorCacheHandler = (error)=>{
    (0, $2YZCu.default).safeErrorWithoutCustomerData('jiraServicedeskIsItsmProjectResource', error.message);
    (0, $jcw0u.default)({
        meta: {
            id: 'jiraServicedeskIsItsmProjectResource',
            packageName: 'jiraSpa'
        },
        error: error,
        sendToPrivacyUnsafeSplunk: true
    });
    throw error;
};
const $fd3e8076f980c90d$var$getIsItsmProject = async (baseUrl, projectIdOrKey)=>{
    if (!projectIdOrKey) return false;
    try {
        if ((0, $6s1PB.expValEquals)('jira_caching_layer_milestone_1_exp', 'cohort', 'variation')) {
            const fetchStartTime = performance.now();
            const data = await (0, $9IjUd.fetchJsonWithCache)(`${baseUrl}/rest/servicedesk/onboarding/1/itsm/${projectIdOrKey}/is-itsm`, $fd3e8076f980c90d$var$onFetchErrorCacheHandler);
            (0, $bFU4G.addSpanToAll)('fetch', 'rest/servicedesk/onboarding/1/itsm/projectIdOrKey/is-itsm-fetchWithCache', [
                {
                    name: 'network'
                }
            ], fetchStartTime, performance.now());
            (0, $x9xyg.setMark)((0, $8PRuf.prefetchApiReadyMark));
            return data;
        }
        const fetchStartTime = performance.now();
        const data = await (0, $7f4tk.default)(`${baseUrl}/rest/servicedesk/onboarding/1/itsm/${projectIdOrKey}/is-itsm`);
        (0, $bFU4G.addSpanToAll)('fetch', 'rest/servicedesk/onboarding/1/itsm/projectIdOrKey/is-itsm', [
            {
                name: 'network'
            }
        ], fetchStartTime, performance.now());
        (0, $x9xyg.setMark)((0, $8PRuf.prefetchApiReadyMark));
        return data;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $2YZCu.default).safeErrorWithoutCustomerData('jiraServicedeskIsItsmProjectResource', error.message);
        (0, $jcw0u.default)({
            meta: {
                id: 'jiraServicedeskIsItsmProjectResource',
                packageName: 'jiraSpa'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    }
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$fd3e8076f980c90d$export$2e2bcd8739ae039 = ({ match: match }, { tenantContext: tenantContext })=>{
    // Since this will be mostly used for onboarding, there are some special pages that either does not have TenantContextContainer in the react tree or somehow not
    // getting tenantContext populated properly, add this check to avoid flooding sentry
    if (tenantContext === undefined) throw new Error('tenantContext is missing');
    // Early exit on these cases and return a valid response. We don't want to flood sentry.
    if (!(0, $9NiTW.checkAuthentication)(tenantContext) || !(0, $3RV1W.checkLicense)(tenantContext, 'servicedesk')) throw new Error('Authentication or licence missing');
    const projectIdOrKey = (0, $dK8AG.getProjectKeyOrId)(match);
    return $fd3e8076f980c90d$var$getIsItsmProject(tenantContext.baseUrl, projectIdOrKey);
};

});
parcelRegister("9IjUd", function(module, exports) {

$parcel$export(module.exports, "fetchJsonWithCache", () => $d85505379126d65b$export$4c299511a1966b73);

var $7f4tk = parcelRequire("7f4tk");

var $aDezs = parcelRequire("aDezs");
const $d85505379126d65b$export$4c299511a1966b73 = (0, $aDezs.withCache)((0, $7f4tk.default));

});
parcelRegister("aDezs", function(module, exports) {

$parcel$export(module.exports, "withCache", () => $807c4ec3ea856331$export$33b32b3abf8170f0);

var $x9xyg = parcelRequire("x9xyg");

var $jcw0u = parcelRequire("jcw0u");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $4ZYuM = parcelRequire("4ZYuM");

var $4sfTg = parcelRequire("4sfTg");

var $6JHHz = parcelRequire("6JHHz");

var $dw7IP = parcelRequire("dw7IP");
const $807c4ec3ea856331$export$33b32b3abf8170f0 = (fn)=>async (url, onFnErrorCacheHandler, maxAge = (0, $4ZYuM.SEVEN_DAYS_IN_MILLIS), options = {})=>{
        if (false) return fn(url, options);
        try {
            if (!(0, $6s1PB.expValEquals)('jira_caching_layer_milestone_1_exp', 'cohort', 'variation')) return fn(url, options);
            const cachedKey = (0, $4sfTg.createCacheKey)(url);
            const readMeasureName = 'indexed-db-cache-read';
            const readStartMark = `${readMeasureName}:start`;
            const readEndMark = `${readMeasureName}:end`;
            (0, $x9xyg.setMark)(readStartMark);
            const cachedData = await (0, $dw7IP.jiraCache).get(cachedKey);
            (0, $x9xyg.setMark)(readEndMark);
            (0, $x9xyg.setMeasure)(readMeasureName, readStartMark, readEndMark);
            if (cachedData !== undefined && Date.now() < cachedData.expiresAt) return cachedData.data;
            let data;
            try {
                data = await fn(url, options);
            } catch (error) {
                if (onFnErrorCacheHandler) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                data = onFnErrorCacheHandler(error);
                else throw error;
            }
            const writeMeasureName = 'indexed-db-cache-write';
            const writeStartMark = `${writeMeasureName}:start`;
            const writeEndMark = `${writeMeasureName}:end`;
            (0, $x9xyg.setMark)(writeStartMark);
            (0, $dw7IP.jiraCache).set(cachedKey, {
                data: data,
                expiresAt: Date.now() + maxAge
            }).then(()=>{
                (0, $x9xyg.setMark)(writeEndMark);
                (0, $x9xyg.setMeasure)(writeMeasureName, writeStartMark, writeEndMark);
            });
            return data;
        } catch (error) {
            if ((0, $4R6GH.fg)('jcl_error_handling_and_conditional_skip_sentry')) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            (0, $6JHHz.errorHandler)(error, 'withCache');
            else (0, $jcw0u.default)({
                meta: {
                    id: 'withCache',
                    packageName: (0, $4ZYuM.PACKAGE_NAME),
                    teamName: (0, $4ZYuM.TEAM_NAME)
                },
                error: new Error('Error in JCL withCache'),
                attributes: {
                    cause: error instanceof Error ? error.message : 'Not known'
                },
                sendToPrivacyUnsafeSplunk: true,
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                skipSentry: (0, $jcw0u.isNetworkError)(error)
            });
            return fn(url, options);
        }
    };

});
parcelRegister("4ZYuM", function(module, exports) {

$parcel$export(module.exports, "PACKAGE_NAME", () => $14fef84cc1d179c0$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "TEAM_NAME", () => $14fef84cc1d179c0$export$d57b6b390e78d90f);
$parcel$export(module.exports, "SEVEN_DAYS_IN_MILLIS", () => $14fef84cc1d179c0$export$b14f1fa28090cb18);
$parcel$export(module.exports, "CACHE_NAME_PREFIX", () => $14fef84cc1d179c0$export$7c8c9e2fd09cd6cd);
const $14fef84cc1d179c0$export$b8b9d90f9e5bd72b = 'jiraCachingLayer';
const $14fef84cc1d179c0$export$d57b6b390e78d90f = 'aurum';
const $14fef84cc1d179c0$export$b14f1fa28090cb18 = 604800000;
const $14fef84cc1d179c0$export$7c8c9e2fd09cd6cd = 'jira-cache';

});

parcelRegister("4sfTg", function(module, exports) {

$parcel$export(module.exports, "createCacheKey", () => $ae7ce70bbd907415$export$aa68fd26e593cc7e);

var $4Pf62 = parcelRequire("4Pf62");
const $ae7ce70bbd907415$export$aa68fd26e593cc7e = (endpoint)=>{
    const { atlassianAccountId: atlassianAccountId, cloudId: cloudId } = (0, $4Pf62.getTenantContext_DEPRECATED_DO_NOT_USE)();
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const url = new URL(endpoint, window.location.origin);
    const searchParams = new URLSearchParams(url.search);
    const sortedParams = new URLSearchParams([
        ...searchParams.entries()
    ].sort());
    url.search = sortedParams.toString();
    const prefix = (atlassianAccountId + cloudId).replace(/-/g, '');
    const endpointWithSearch = prefix + url.pathname + url.search;
    return endpointWithSearch.replace(/[/?&=]/g, '-').substring(1);
};

});

parcelRegister("6JHHz", function(module, exports) {

$parcel$export(module.exports, "errorHandler", () => $17322007fa00b48f$export$cc3fdd528b56c4a9);

var $jcw0u = parcelRequire("jcw0u");

var $4ZYuM = parcelRequire("4ZYuM");
const $17322007fa00b48f$export$3b21ec5932035f63 = [
    'Internal error.',
    'Internal error opening backing store for indexedDB.open.',
    "Can't find variable: indexedDB",
    'Error looking up record in object store by key range',
    "IDBDatabase.transaction: 'keyval' is not a known object store name",
    'A mutation operation was attempted on a database that did not allow mutations.',
    'Encountered full disk while opening backing store for indexedDB.open.',
    "Failed to execute 'transaction' on 'IDBDatabase': One of the specified object stores was not found.",
    'Internal error retrieving bucket data directory.',
    'Connection to Indexed Database server lost. Refresh the page to try again',
    'The current transaction exceeded its quota limitations.',
    'The operation failed for reasons unrelated to the database itself and not covered by any other error code.',
    'Attempt to get a record from database without an in-progress transaction'
];
const $17322007fa00b48f$var$shouldSkipSentry = (error)=>(0, $jcw0u.isNetworkError)(error) || $17322007fa00b48f$export$3b21ec5932035f63.includes(error?.message);
const $17322007fa00b48f$export$cc3fdd528b56c4a9 = (error, source)=>{
    const cause = error instanceof Error ? error.message : 'Not known';
    (0, $jcw0u.default)({
        meta: {
            id: source,
            packageName: (0, $4ZYuM.PACKAGE_NAME),
            teamName: (0, $4ZYuM.TEAM_NAME)
        },
        error: new Error(`JCL ${source} - ${cause}`, {
            cause: error
        }),
        attributes: {
            cause: cause
        },
        sendToPrivacyUnsafeSplunk: true,
        skipSentry: $17322007fa00b48f$var$shouldSkipSentry(error)
    });
};

});

parcelRegister("dw7IP", function(module, exports) {

$parcel$export(module.exports, "jiraCache", () => $646f3c3ba9013057$export$8b9e5c9ea3bf5aac);

var $sn9QA = parcelRequire("sn9QA");

var $4ZYuM = parcelRequire("4ZYuM");
const $646f3c3ba9013057$export$8b9e5c9ea3bf5aac = (0, $sn9QA.createIndexedDBStorageProvider)((0, $4ZYuM.CACHE_NAME_PREFIX), {
    shouldAutoReconnect: true
});

});
parcelRegister("sn9QA", function(module, exports) {

$parcel$export(module.exports, "createIndexedDBStorageProvider", () => $cf3437e9474a0e2b$export$6ba36c4f5fb8919d);

var $gJBT6 = parcelRequire("gJBT6");

var $8vEj7 = parcelRequire("8vEj7");
const $cf3437e9474a0e2b$export$6ba36c4f5fb8919d = (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((appPrefix, options)=>{
    if (!appPrefix) throw Error("appPrefix can not be empty. It's used to separate apps");
    const provider = (0, $8vEj7.createStorageProvider)(appPrefix);
    if (options?.shouldAutoReconnect) return (0, $8vEj7.withAutoReconnect)(provider);
    return provider;
});

});
parcelRegister("8vEj7", function(module, exports) {

$parcel$export(module.exports, "createStorageProvider", () => $33b8db71261fb346$export$8441605555fbd60c);
$parcel$export(module.exports, "withAutoReconnect", () => $33b8db71261fb346$export$8432fe49db7d8865);

var $jIIX7 = parcelRequire("jIIX7");
const $33b8db71261fb346$export$7382f85ef4ff4314 = (prefix, key)=>`${prefix.replace(/_*$/, '')}__${key || ''}`;
const $33b8db71261fb346$var$createCustomStore = ()=>(0, $jIIX7.createStore)('keyval-store', 'keyval');
let $33b8db71261fb346$var$customStore;
const $33b8db71261fb346$var$getStore = ()=>{
    let store = $33b8db71261fb346$var$customStore;
    if (!store) {
        $33b8db71261fb346$var$customStore = $33b8db71261fb346$var$createCustomStore();
        store = $33b8db71261fb346$var$customStore;
    }
    return store;
};
const $33b8db71261fb346$export$8441605555fbd60c = (appPrefix)=>{
    const KEYS_STORE_PREFIX = $33b8db71261fb346$export$7382f85ef4ff4314(appPrefix);
    const prefix = (key)=>$33b8db71261fb346$export$7382f85ef4ff4314(appPrefix, key);
    // Runtime check to ensure a key is provided as the prefix without a key
    // holds an array of all the keys that are prefixed by this store
    const assertKey = (key)=>{
        if (!key) throw Error('You must provide a key');
    };
    // Calling `clearAll` would require us to iterate over every key in the
    // indexed-db, filtering by this instance's prefix and subsequently deleting
    // all the filtered keys. As indexed-db gains traction within Jira, this
    // will quickly become an expensive operation. To counteract this, we
    // instead store all the keys that this instance has created so that when it
    // comes time to clear them all, we simply just have to clear every key in
    // this store. This removes the need for iterating and filtering all
    // together.
    const updateStoreKeys = async (key, remove = false)=>(0, $jIIX7.update)(KEYS_STORE_PREFIX, (currentKeys)=>{
            const storeKeys = new Set(currentKeys);
            if (remove) {
                storeKeys.delete(key);
                return Array.from(storeKeys.values());
            }
            storeKeys.add(key);
            return Array.from(storeKeys.values());
        }, $33b8db71261fb346$var$getStore());
    return {
        async get (key) {
            assertKey(key);
            return (0, $jIIX7.get)(prefix(key), $33b8db71261fb346$var$getStore());
        },
        async remove (key) {
            assertKey(key);
            const prefixedKey = prefix(key);
            await (0, $jIIX7.del)(prefixedKey, $33b8db71261fb346$var$getStore());
            return updateStoreKeys(prefixedKey, true);
        },
        async clearAll () {
            const prefixedKeys = await (0, $jIIX7.get)(KEYS_STORE_PREFIX, $33b8db71261fb346$var$getStore());
            if (!prefixedKeys || prefixedKeys.length === 0) return undefined;
            return (0, $jIIX7.delMany)(prefixedKeys.concat(KEYS_STORE_PREFIX));
        },
        async set (key, value) {
            assertKey(key);
            const prefixedKey = prefix(key);
            if (typeof value === 'function') // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
            (0, $jIIX7.update)(prefixedKey, value);
            else (0, $jIIX7.set)(prefixedKey, value, $33b8db71261fb346$var$getStore());
            return updateStoreKeys(prefixedKey);
        },
        async reconnect () {
            $33b8db71261fb346$var$customStore = $33b8db71261fb346$var$createCustomStore();
        }
    };
};
const $33b8db71261fb346$export$8432fe49db7d8865 = (storageProvider)=>({
        async get (...args) {
            try {
                return await storageProvider.get(...args);
            } catch (e) {
                if (e instanceof Error) {
                    await storageProvider.reconnect?.();
                    return storageProvider.get(...args);
                }
                throw e;
            }
        },
        async set (...args) {
            try {
                return await storageProvider.set(...args);
            } catch (e) {
                if (e instanceof Error) {
                    await storageProvider.reconnect?.();
                    return storageProvider.set(...args);
                }
                throw e;
            }
        },
        async remove (...args) {
            try {
                return await storageProvider.remove(...args);
            } catch (e) {
                if (e instanceof Error) {
                    await storageProvider.reconnect?.();
                    return storageProvider.remove(...args);
                }
                throw e;
            }
        },
        async clearAll (...args) {
            try {
                return await storageProvider.clearAll(...args);
            } catch (e) {
                if (e instanceof Error) {
                    await storageProvider.reconnect?.();
                    return storageProvider.clearAll(...args);
                }
                throw e;
            }
        },
        async reconnect () {
            await storageProvider.reconnect?.();
        }
    });

});
parcelRegister("jIIX7", function(module, exports) {

$parcel$export(module.exports, "createStore", () => $e5b4ff07e835609c$export$f51a9068ac82ea43);
$parcel$export(module.exports, "get", () => $e5b4ff07e835609c$export$3988ae62b71be9a3);
$parcel$export(module.exports, "set", () => $e5b4ff07e835609c$export$adaa4cf7ef1b65be);
$parcel$export(module.exports, "update", () => $e5b4ff07e835609c$export$722fbec263ad908a);
$parcel$export(module.exports, "del", () => $e5b4ff07e835609c$export$1d2f21e549771e67);
$parcel$export(module.exports, "delMany", () => $e5b4ff07e835609c$export$c8aa84257229cac8);
function $e5b4ff07e835609c$export$b327150396135fe7(request) {
    return new Promise((resolve, reject)=>{
        // @ts-ignore - file size hacks
        request.oncomplete = request.onsuccess = ()=>resolve(request.result);
        // @ts-ignore - file size hacks
        request.onabort = request.onerror = ()=>reject(request.error);
    });
}
function $e5b4ff07e835609c$export$f51a9068ac82ea43(dbName, storeName) {
    const request = indexedDB.open(dbName);
    request.onupgradeneeded = ()=>request.result.createObjectStore(storeName);
    const dbp = $e5b4ff07e835609c$export$b327150396135fe7(request);
    return (txMode, callback)=>dbp.then((db)=>callback(db.transaction(storeName, txMode).objectStore(storeName)));
}
let $e5b4ff07e835609c$var$defaultGetStoreFunc;
function $e5b4ff07e835609c$var$defaultGetStore() {
    if (!$e5b4ff07e835609c$var$defaultGetStoreFunc) $e5b4ff07e835609c$var$defaultGetStoreFunc = $e5b4ff07e835609c$export$f51a9068ac82ea43('keyval-store', 'keyval');
    return $e5b4ff07e835609c$var$defaultGetStoreFunc;
}
/**
 * Get a value by its key.
 *
 * @param key
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $e5b4ff07e835609c$export$3988ae62b71be9a3(key, customStore = $e5b4ff07e835609c$var$defaultGetStore()) {
    return customStore('readonly', (store)=>$e5b4ff07e835609c$export$b327150396135fe7(store.get(key)));
}
/**
 * Set a value with a key.
 *
 * @param key
 * @param value
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $e5b4ff07e835609c$export$adaa4cf7ef1b65be(key, value, customStore = $e5b4ff07e835609c$var$defaultGetStore()) {
    return customStore('readwrite', (store)=>{
        store.put(value, key);
        return $e5b4ff07e835609c$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Set multiple values at once. This is faster than calling set() multiple times.
 * It's also atomic – if one of the pairs can't be added, none will be added.
 *
 * @param entries Array of entries, where each entry is an array of `[key, value]`.
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $e5b4ff07e835609c$export$daa0a5170277c7a8(entries, customStore = $e5b4ff07e835609c$var$defaultGetStore()) {
    return customStore('readwrite', (store)=>{
        entries.forEach((entry)=>store.put(entry[1], entry[0]));
        return $e5b4ff07e835609c$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Get multiple values by their keys
 *
 * @param keys
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $e5b4ff07e835609c$export$5df405cccea42673(keys, customStore = $e5b4ff07e835609c$var$defaultGetStore()) {
    return customStore('readonly', (store)=>Promise.all(keys.map((key)=>$e5b4ff07e835609c$export$b327150396135fe7(store.get(key)))));
}
/**
 * Update a value. This lets you see the old value and update it as an atomic operation.
 *
 * @param key
 * @param updater A callback that takes the old value and returns a new value.
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $e5b4ff07e835609c$export$722fbec263ad908a(key, updater, customStore = $e5b4ff07e835609c$var$defaultGetStore()) {
    return customStore('readwrite', (store)=>// Need to create the promise manually.
        // If I try to chain promises, the transaction closes in browsers
        // that use a promise polyfill (IE10/11).
        new Promise((resolve, reject)=>{
            store.get(key).onsuccess = function() {
                try {
                    store.put(updater(this.result), key);
                    resolve($e5b4ff07e835609c$export$b327150396135fe7(store.transaction));
                } catch (err) {
                    reject(err);
                }
            };
        }));
}
/**
 * Delete a particular key from the store.
 *
 * @param key
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $e5b4ff07e835609c$export$1d2f21e549771e67(key, customStore = $e5b4ff07e835609c$var$defaultGetStore()) {
    return customStore('readwrite', (store)=>{
        store.delete(key);
        return $e5b4ff07e835609c$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Delete multiple keys at once.
 *
 * @param keys List of keys to delete.
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $e5b4ff07e835609c$export$c8aa84257229cac8(keys, customStore = $e5b4ff07e835609c$var$defaultGetStore()) {
    return customStore('readwrite', (store)=>{
        keys.forEach((key)=>store.delete(key));
        return $e5b4ff07e835609c$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Clear all values in the store.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $e5b4ff07e835609c$export$42ffd38884aecdac(customStore = $e5b4ff07e835609c$var$defaultGetStore()) {
    return customStore('readwrite', (store)=>{
        store.clear();
        return $e5b4ff07e835609c$export$b327150396135fe7(store.transaction);
    });
}
function $e5b4ff07e835609c$var$eachCursor(store, callback) {
    store.openCursor().onsuccess = function() {
        if (!this.result) return;
        callback(this.result);
        this.result.continue();
    };
    return $e5b4ff07e835609c$export$b327150396135fe7(store.transaction);
}
/**
 * Get all keys in the store.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $e5b4ff07e835609c$export$ed97f33186d4b816(customStore = $e5b4ff07e835609c$var$defaultGetStore()) {
    return customStore('readonly', (store)=>{
        // Fast path for modern browsers
        if (store.getAllKeys) return $e5b4ff07e835609c$export$b327150396135fe7(store.getAllKeys());
        const items = [];
        return $e5b4ff07e835609c$var$eachCursor(store, (cursor)=>items.push(cursor.key)).then(()=>items);
    });
}
/**
 * Get all values in the store.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $e5b4ff07e835609c$export$68c286be0e7e55b7(customStore = $e5b4ff07e835609c$var$defaultGetStore()) {
    return customStore('readonly', (store)=>{
        // Fast path for modern browsers
        if (store.getAll) return $e5b4ff07e835609c$export$b327150396135fe7(store.getAll());
        const items = [];
        return $e5b4ff07e835609c$var$eachCursor(store, (cursor)=>items.push(cursor.value)).then(()=>items);
    });
}
/**
 * Get all entries in the store. Each entry is an array of `[key, value]`.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $e5b4ff07e835609c$export$3e9f948b41964866(customStore = $e5b4ff07e835609c$var$defaultGetStore()) {
    return customStore('readonly', (store)=>{
        // Fast path for modern browsers
        // (although, hopefully we'll get a simpler path some day)
        if (store.getAll && store.getAllKeys) return Promise.all([
            $e5b4ff07e835609c$export$b327150396135fe7(store.getAllKeys()),
            $e5b4ff07e835609c$export$b327150396135fe7(store.getAll())
        ]).then(([keys, values])=>keys.map((key, i)=>[
                    key,
                    values[i]
                ]));
        const items = [];
        return customStore('readonly', (store)=>$e5b4ff07e835609c$var$eachCursor(store, (cursor)=>items.push([
                    cursor.key,
                    cursor.value
                ])).then(()=>items));
    });
}

});






parcelRegister("8PRuf", function(module, exports) {

$parcel$export(module.exports, "appBundleReadyMark", () => $0ec5205bf4957ca4$export$7e50945a65dd40e);
$parcel$export(module.exports, "prefetchApiReadyMark", () => $0ec5205bf4957ca4$export$17cbe723d23101d8);
$parcel$export(module.exports, "prefetchApiStartMark", () => $0ec5205bf4957ca4$export$887fadb22e7c7735);
$parcel$export(module.exports, "jswRenderStartMark", () => $0ec5205bf4957ca4$export$bd099c0a906f4b3f);
$parcel$export(module.exports, "jswCreateReduxStoreStartMark", () => $0ec5205bf4957ca4$export$d23ef9e7633e30e7);
$parcel$export(module.exports, "jswCreateReduxStoreEndMark", () => $0ec5205bf4957ca4$export$319da6d901948a6d);
$parcel$export(module.exports, "jswTransformCriticalDataStartMark", () => $0ec5205bf4957ca4$export$f0b6622cdc5c7e4f);
$parcel$export(module.exports, "jswTransformCriticalDataEndMark", () => $0ec5205bf4957ca4$export$37e82663aa1e79a8);
$parcel$export(module.exports, "jswReduxSoftwareAppLoadedStartMark", () => $0ec5205bf4957ca4$export$21146514eacceb12);
$parcel$export(module.exports, "jswReduxSoftwareAppLoadedEndMark", () => $0ec5205bf4957ca4$export$4eb8d44ddb14424a);


var $hXKq5 = parcelRequire("hXKq5");
const $0ec5205bf4957ca4$export$7e50945a65dd40e = (0, $hXKq5.getPrefixedMarkName)((0, $ce556f125dee8174$export$ff834eccc35b9089));
const $0ec5205bf4957ca4$export$17cbe723d23101d8 = (0, $hXKq5.getPrefixedMarkName)((0, $ce556f125dee8174$export$86b05e34d462ead8));
const $0ec5205bf4957ca4$export$887fadb22e7c7735 = (0, $hXKq5.getPrefixedMarkName)((0, $ce556f125dee8174$export$d6a604a7d9a390fb));
const $0ec5205bf4957ca4$export$bd099c0a906f4b3f = (0, $hXKq5.getPrefixedMarkName)((0, $ce556f125dee8174$export$3ae43cc1782d058f));
const $0ec5205bf4957ca4$export$d23ef9e7633e30e7 = (0, $hXKq5.getPrefixedMarkName)((0, $ce556f125dee8174$export$363f6703ffa600be));
const $0ec5205bf4957ca4$export$319da6d901948a6d = (0, $hXKq5.getPrefixedMarkName)((0, $ce556f125dee8174$export$e87b74567b79c8));
const $0ec5205bf4957ca4$export$f0b6622cdc5c7e4f = (0, $hXKq5.getPrefixedMarkName)((0, $ce556f125dee8174$export$99fe642459a8b02));
const $0ec5205bf4957ca4$export$37e82663aa1e79a8 = (0, $hXKq5.getPrefixedMarkName)((0, $ce556f125dee8174$export$ab1f5705fc8e0571));
const $0ec5205bf4957ca4$export$21146514eacceb12 = (0, $hXKq5.getPrefixedMarkName)((0, $ce556f125dee8174$export$8c3a9046da692c35));
const $0ec5205bf4957ca4$export$4eb8d44ddb14424a = (0, $hXKq5.getPrefixedMarkName)((0, $ce556f125dee8174$export$5aa497d1efdcc5bf));

});
const $ce556f125dee8174$export$56940a9488e85199 = 'jira.fe.spa-';
const $ce556f125dee8174$export$45c4b6bf7935c69a = `${$ce556f125dee8174$export$56940a9488e85199}start`;
const $ce556f125dee8174$export$135c96ab5afee429 = 'ssr.spa.rendered';
const $ce556f125dee8174$export$ff834eccc35b9089 = 'appBundleReady';
const $ce556f125dee8174$export$86b05e34d462ead8 = 'prefetchApiReady';
const $ce556f125dee8174$export$d6a604a7d9a390fb = 'prefetchApiStart';
const $ce556f125dee8174$export$3ae43cc1782d058f = 'jswRenderStart';
const $ce556f125dee8174$export$363f6703ffa600be = 'jswCreateReduxStoreStart';
const $ce556f125dee8174$export$e87b74567b79c8 = 'jswCreateReduxStoreEnd';
const $ce556f125dee8174$export$99fe642459a8b02 = 'jswTransformCriticalDataStart';
const $ce556f125dee8174$export$ab1f5705fc8e0571 = 'jswTransformCriticalDataEnd';
const $ce556f125dee8174$export$8c3a9046da692c35 = 'jswReduxSoftwareAppLoadedStart';
const $ce556f125dee8174$export$5aa497d1efdcc5bf = 'jswReduxSoftwareAppLoadedEnd';
const $ce556f125dee8174$export$99c08ec92759c71c = 'tti-raf-mark';
const $ce556f125dee8174$export$48552baa9db8ce1d = 'tti-raf';


parcelRegister("9NiTW", function(module, exports) {

$parcel$export(module.exports, "checkAuthentication", () => $ad297a7f2ce81084$export$b8dbb7d6029c5413);
$parcel$export(module.exports, "AuthenticationCheck", () => $ad297a7f2ce81084$export$e9b9096e887386fe);

var $5uXOq = parcelRequire("5uXOq");

var $9OXo1 = parcelRequire("9OXo1");

var $38Y30 = parcelRequire("38Y30");
const $ad297a7f2ce81084$export$b8dbb7d6029c5413 = (tenantContext)=>Boolean(tenantContext.atlassianAccountId);
const $ad297a7f2ce81084$export$e9b9096e887386fe = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9OXo1.TenantContextSubscriber), null, ({ tenantContext: tenantContext })=>{
        if ($ad297a7f2ce81084$export$b8dbb7d6029c5413(tenantContext)) return children;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $38Y30.RedirectToLoginPage), null);
    });

});
parcelRegister("38Y30", function(module, exports) {

$parcel$export(module.exports, "RedirectToLoginPage", () => $08f8c3f776d557a9$export$938182bd3fddc3a8);

var $5uXOq = parcelRequire("5uXOq");

var $7tQej = parcelRequire("7tQej");
var $ieDtd = parcelRequire("ieDtd");
var $doZTA = parcelRequire("doZTA");
const $08f8c3f776d557a9$export$3da29de62ed7a388 = ({ to: to })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("script", {
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            __html: `window.location.assign("${to}")`
        }
    });
$08f8c3f776d557a9$export$3da29de62ed7a388.displayName = 'InlineRedirect';
const $08f8c3f776d557a9$export$938182bd3fddc3a8 = ()=>{
    const [{ location: { pathname: pathname, search: search } }] = (0, $doZTA.useRouter)();
    const redirectUrl = pathname + search;
    const encodedRedirectUrl = encodeURIComponent(redirectUrl);
    let path = `/login.jsp?os_destination=${encodedRedirectUrl}`;
    const parentProductQueryName = 'parentProduct';
    const [parentProduct] = (0, $ieDtd.useQueryParam)(parentProductQueryName);
    if (pathname.endsWith('/embed')) {
        const searchParams = new URLSearchParams(search);
        // We need to remove parentProduct param as it is only used in embed urls
        searchParams.delete(parentProductQueryName);
        /**
		 * encodedLink is the link to the non embedded version of the embed url.
		 * So, we strip out the /embed suffix from path
		 */ let encodedLink = encodeURIComponent(`${pathname.slice(0, -6)}?${searchParams}`);
        /**
		 * this is the specific case for create issue embed, where we need to redirect
		 * user to your-work page with create issue as true to open GIC by default.
		 * We will remove this when we FPIC exp implemented for GIC
		 */ if (pathname.includes('/issues/create')) encodedLink = encodeURIComponent('/jira/your-work?createissue=true');
        const encodedParentProduct = encodeURIComponent(parentProduct || '');
        path = `/jira-login/embed?destination=${encodedRedirectUrl}&link=${encodedLink}&parentProduct=${encodedParentProduct}`;
    }
    return false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($08f8c3f776d557a9$export$3da29de62ed7a388, {
        to: path
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
        to: path
    });
};

});


parcelRegister("3RV1W", function(module, exports) {

$parcel$export(module.exports, "checkLicense", () => $6334356fa938c5d8$export$fe2591be8b7e59ce);
$parcel$export(module.exports, "LicenseCheck", () => $6334356fa938c5d8$export$944be0b3bf2a6feb);

var $5uXOq = parcelRequire("5uXOq");

var $9OXo1 = parcelRequire("9OXo1");
const $6334356fa938c5d8$var$appPermissionMapper = {
    software: 'hasSoftwareAccess',
    servicedesk: 'hasServiceDeskAccess',
    customerservice: 'hasCustomerServiceAccess'
};
const $6334356fa938c5d8$export$fe2591be8b7e59ce = (tenantContext, type)=>Boolean(tenantContext.appPermissions && tenantContext.appPermissions[$6334356fa938c5d8$var$appPermissionMapper[type]]);
const $6334356fa938c5d8$export$944be0b3bf2a6feb = ({ children: children, type: type })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9OXo1.TenantContextSubscriber), null, ({ tenantContext: tenantContext })=>{
        const result = $6334356fa938c5d8$export$fe2591be8b7e59ce(tenantContext, type);
        return children({
            result: result
        });
    });

});



//# sourceMappingURL=async-resource-servicedesk-is-itsm-project.5318abca.js.map
